import { render, staticRenderFns } from "./EditorBar.vue?vue&type=template&id=4ddcf53e&scoped=true"
import script from "./EditorBar.vue?vue&type=script&lang=js"
export * from "./EditorBar.vue?vue&type=script&lang=js"
import style0 from "./EditorBar.vue?vue&type=style&index=0&id=4ddcf53e&prod&scoped=true&lang=less"
import style1 from "./EditorBar.vue?vue&type=style&index=1&id=4ddcf53e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddcf53e",
  null
  
)

export default component.exports